module.exports = __webpack_public_path__ + "static/patriciawork5-ef449b7926805d275369ec2de445910c.jpg";